import React from 'react';
import { Link } from 'react-router-dom';
import { MessageSquare, Twitter, Instagram, Youtube } from 'lucide-react';
import { FaDiscord } from 'react-icons/fa';
import { AiFillTikTok } from 'react-icons/ai';

const socialLinks = [
  { Icon: FaDiscord, label: 'discord', highlighted: true, href: 'https://discord.com/invite/RwpMfRdzex' },
  { Icon: MessageSquare, label: 'reddit', href: 'https://www.reddit.com/user/Unable-Repair-1035/' },
  { Icon: Twitter, label: 'twitter', href: 'https://twitter.com/frostboundwow' },
  { Icon: Instagram, label: 'instagram', href: 'https://instagram.com/frostboundwow' },
  { Icon: AiFillTikTok, label: 'tiktok', href: 'https://tiktok.com/@frostboundwow' },
  { Icon: Youtube, label: 'youtube', href: 'https://youtube.com/@frostboundwow' },
];

const footerLinks = [
  { label: 'Términos', to: '/terminos' },
  { label: 'Privacidad', to: '/privacidad' },
  { label: 'Contacto', to: '/soporte' },
];

export default function Footer({ fixed = true }) {
  const fixedClass = fixed
    ? 'fixed bottom-0 left-0 right-0 z-40 border-t border-white/10 bg-[#0b1120]/92 backdrop-blur-md'
    : '';

  return (
    <footer className={`site-footer anim-fade-up ${fixedClass}`} style={{ animationDelay: '1s' }} data-testid="site-footer">
      <div className="footer-links">
        {footerLinks.map(({ label, to }) => (
          <Link key={label} to={to} className="footer-link" data-testid={`footer-link-${label.toLowerCase()}`}>
            {label}
          </Link>
        ))}
      </div>
      <div
        className="footer-dev-signature"
        style={{
          fontSize: 11,
          letterSpacing: '0.04em',
          color: 'rgba(255, 255, 255, 0.55)',
        }}
      >
        © 2026 Frostbound. Todos los derechos reservados.
      </div>
      <div className="footer-socials">
        {socialLinks.map(({ Icon, label, href, highlighted }) => (
          <a
            key={label}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className={`social-icon ${highlighted ? 'social-icon--highlighted' : ''}`}
            data-testid={`social-${label}`}
            aria-label={label}
          >
            <Icon size={17} />
          </a>
        ))}
      </div>
    </footer>
  );
}
